const PATIENT_STATUS = {
    Waiting : 1,
    Consultation : 4,
    Pharmacy: 5,
    Complete: 3
  }



  export default PATIENT_STATUS